// Auto-generated per-query builders for Connection
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ConnectionReadAPI, ConnectionWriteAPI, ConnectionReadAPISchema, ConnectionWriteAPISchema } from '../types/connection';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ConnectionEndA, ConnectionEndB, HasAttribute, HasAttributeValue, HasDerivedValue, ItemFlowRealizedBy, Mentions, RealizesConnection, Satisfies } from '../../relationships/relationship';

import { PhysicalPart } from './physicalpart';
import { ItemFlow } from './itemflow';
import { Requirement } from './requirement';
import { Port } from './port';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';





// Builder chain for query: rflp-connection-by-id

export interface RflpConnectionByIdBuilder_0 {
  get(id: string): RflpConnectionByIdBuilder_1;
  filter(conditions: { id: string }): RflpConnectionByIdBuilder_1;
}

export interface RflpConnectionByIdBuilder_1 {
  all(): Promise<Connection[]>;
  first(): Promise<Connection | null>;
  get(): Promise<Connection[]>;
  execute(): Promise<Connection[]>;
}


// Union of all query entry points
export type ConnectionQueryBuilder = RflpConnectionByIdBuilder_0;

// Available query names for .setQuery()
export type ConnectionQueryNames = "rflp-connection-by-id";

// Type narrowing for .setQuery()
export type ConnectionBuilderForQuery<Q extends ConnectionQueryNames> =
  Q extends "rflp-connection-by-id" ? RflpConnectionByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ConnectionInstanceQueryResult<Q extends ConnectionQueryNames> =
  Q extends "rflp-connection-by-id" ? RflpConnectionByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-connection-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ConnectionQueryNames>(queryName: Q): ConnectionBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Connection extends Partial<ConnectionReadAPI> {}
export class Connection extends NeoNodeBase<ConnectionReadAPI, ConnectionWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Connection";
  static readonly readSchema = ConnectionReadAPISchema;
  static readonly writeSchema = ConnectionWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    realized_by: { target: "PhysicalPart", cardinality: "many", isParent: false, relClass: "RealizesConnection", direction: "in" },
    satisfies: { target: "Requirement", cardinality: "many", isParent: false, relClass: "Satisfies", direction: "out" },
    realizes_item_flows: { target: "ItemFlow", cardinality: "many", isParent: false, relClass: "ItemFlowRealizedBy", direction: "in" },
    port_a: { target: "Port", cardinality: "one", isParent: true, relClass: "ConnectionEndA", direction: "out" },
    port_b: { target: "Port", cardinality: "one", isParent: true, relClass: "ConnectionEndB", direction: "out" },
  };

  protected get modelName(): string {
    return 'Connection';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Connection.label;
  }


  constructor(data: Partial<ConnectionWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ConnectionReadAPI, loadContext?: Record<string, any>): Connection {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { realized_by, satisfies, realizes_item_flows, port_a, port_b, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ConnectionReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, realized_by: realized_by, satisfies: satisfies, realizes_item_flows: realizes_item_flows, port_a: port_a, port_b: port_b, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Connection.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'realized_by', 'PhysicalPart', ModelRegistry);
    loadManyRelationship(processed, 'satisfies', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'realizes_item_flows', 'ItemFlow', ModelRegistry);
    loadOneRelationship(processed, 'port_a', 'Port', ModelRegistry);
    loadOneRelationship(processed, 'port_b', 'Port', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Connection(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ConnectionQueryBuilder {
    return new QueryBuilderImpl('Connection').filter(conditions) as any;
  }

  static all(): ConnectionQueryBuilder {
    return new QueryBuilderImpl('Connection') as any;
  }

  static async first(): Promise<Connection | null> {
    const results = await new QueryBuilderImpl('Connection').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ConnectionQueryNames>(queryName: Q): ConnectionBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Connection');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ConnectionQueryNames>(queryName: Q): ConnectionInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Connection.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const connection = await Connection.get(id).first();
   * await connection.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await connection.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'realized_by' - Python ORM style (cached)
  get realized_by(): RelationshipManager<this, PhysicalPart> {
    return this.getOrCreateRelationshipManager('realized_by', () => {
      return new RelationshipManager(this, 'realized_by', 'many', RealizesConnection as typeof Relationship);
    });
  }

  // Relationship manager for 'realizes_item_flows' - Python ORM style (cached)
  get realizes_item_flows(): RelationshipManager<this, ItemFlow> {
    return this.getOrCreateRelationshipManager('realizes_item_flows', () => {
      return new RelationshipManager(this, 'realizes_item_flows', 'many', ItemFlowRealizedBy as typeof Relationship);
    });
  }

  // Relationship manager for 'satisfies' - Python ORM style (cached)
  get satisfies(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('satisfies', () => {
      return new RelationshipManager(this, 'satisfies', 'many', Satisfies as typeof Relationship);
    });
  }

  // Relationship manager for 'port_a' - Python ORM style (cached)
  get port_a(): RelationshipManager<this, Port> {
    return this.getOrCreateRelationshipManager('port_a', () => {
      return new RelationshipManager(this, 'port_a', 'one', ConnectionEndA as typeof Relationship);
    });
  }

  // Relationship manager for 'port_b' - Python ORM style (cached)
  get port_b(): RelationshipManager<this, Port> {
    return this.getOrCreateRelationshipManager('port_b', () => {
      return new RelationshipManager(this, 'port_b', 'one', ConnectionEndB as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

}
